/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 22.12.2016.
 */

import {EMIT_VLIVE_SHOW_OVERLAY} from '../../actions/emit/actions-emit';

const INIT_STATE = {
  metadata: {}
};

export default function (state = INIT_STATE, action) {

  switch (action.type) {
    case EMIT_VLIVE_SHOW_OVERLAY:

      return {
        ...state,
        metadata: {
          ...state.metadata,
          [action.payload.vlive_id]: {
            ...action.payload,
            timestamp: Date.now()
          }
        }
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/vlive/reducer-vlive.js